<div class="jeopary-mode-grid">
  <div class="jeopardy-question-panel" style="padding: 2.5vh 3vh;max-width: 25em;">
    <h2 style="font-size: 3vh">{{i18n.str('challengeu.credits_title','Credits')()}}</h2>
    <p class="sanitized-content" [innerHtml]="credits"></p>
  </div>
  <div>
    <br>
    <p class="jeopardy-button primary">
      <a class="neon"
        href="#"
        title="{{i18n.str('challengeu.back_main_menu', 'BACK TO MAIN MENU')()}}"
        routerLink="/main-menu">
        {{i18n.str('challengeu.back_main_menu', 'BACK TO MAIN MENU')()}}
      </a>
    </p>
  </div>
</div>
